export default __webpack_public_path__ + "static/media/banner_bg_ipad_pro.f073224b.svg";